import { useParams } from 'react-router-dom'
import { Row, Col, Button, Breadcrumb } from 'react-bootstrap'

import ImageElement from '../elements/ImageElement'
import TextElement from '../elements/TextElement'
import CarouselElement from '../elements/CarouselElement'

import { FaWhatsapp } from "react-icons/fa"

import imageNoticias1001 from '../assets/images/noticias/noticias_1_001.jpeg'
import imageNoticias1002 from '../assets/images/noticias/noticias_1_002.jpeg'
import imageNoticias1003 from '../assets/images/noticias/noticias_1_003.jpeg'

import imageNoticias2001 from '../assets/images/noticias/noticias_2_001.JPG'
import imageNoticias2002 from '../assets/images/noticias/noticias_2_002.JPG'
import imageNoticias2003 from '../assets/images/noticias/noticias_2_003.JPG'
import imageNoticias2004 from '../assets/images/noticias/noticias_2_004.JPG'
import imageNoticias2005 from '../assets/images/noticias/noticias_2_005.JPG'
import imageNoticias2006 from '../assets/images/noticias/noticias_2_006.jpeg'

import imageNoticias3001 from '../assets/images/noticias/noticias_3_001.jpg'
import imageNoticias3002 from '../assets/images/noticias/noticias_3_002.jpg'
import imageNoticias3003 from '../assets/images/noticias/noticias_3_003.jpeg'
import imageNoticias3004 from '../assets/images/noticias/noticias_3_004.jpeg'
import imageNoticias3005 from '../assets/images/noticias/noticias_3_005.jpg'

import imageNoticias4001 from '../assets/images/noticias/noticias_4_001.jpeg'
import imageNoticias4002 from '../assets/images/noticias/noticias_4_002.jpeg'
import imageNoticias4003 from '../assets/images/noticias/noticias_4_003.jpeg'
import imageNoticias4004 from '../assets/images/noticias/noticias_4_004.jpeg'
import imageNoticias4005 from '../assets/images/noticias/noticias_4_005.jpeg'
import imageNoticias4006 from '../assets/images/noticias/noticias_4_006.jpeg'

import imageNoticias5001 from '../assets/images/noticias/noticias_5_001.jpg'
import imageNoticias5002 from '../assets/images/noticias/noticias_5_002.jpg'

import imageNoticias6001 from '../assets/images/noticias/noticias_6_001.jpg'
import imageNoticias6002 from '../assets/images/noticias/noticias_6_002.jpg'
import imageNoticias6003 from '../assets/images/noticias/noticias_6_003.jpg'
import imageNoticias6004 from '../assets/images/noticias/noticias_6_004.jpg'
import imageNoticias6005 from '../assets/images/noticias/noticias_6_005.jpg'
import imageNoticias6006 from '../assets/images/noticias/noticias_6_006.jpg'
import imageNoticias6007 from '../assets/images/noticias/noticias_6_007.jpg'
import imageNoticias6008 from '../assets/images/noticias/noticias_6_008.jpg'
import imageNoticias6009 from '../assets/images/noticias/noticias_6_009.jpg'
import imageNoticias6010 from '../assets/images/noticias/noticias_6_010.jpg'
import imageNoticias6011 from '../assets/images/noticias/noticias_6_011.jpg'
import imageNoticias6012 from '../assets/images/noticias/noticias_6_012.jpg'
import imageNoticias6013 from '../assets/images/noticias/noticias_6_013.jpg'

function NoticiasConteudo() {
  const { slug } = useParams()

  const elements = [
    {
      title: 'METAL BAURU NAS RUAS POR MAIS DIREITOS PARA TRABALHADORES',
      slug: 'metal-bauru-nas-ruas-por-mais-direitos-para-trabalhadores',
      content: 'A delegação de dirigentes do Sindicato dos Metalúrgicos de Bauru (Metal Bauru) teve importante participação na luta dos trabalhadores ' +
        'por mais direitos na 9ª Plenária Estatutária da Federação dos Metalúrgicos (FEM-CUT/SP), promovida nos dias 14, 15 e 16 de maio de 2025, em Itanhaém (SP).' +
        '<br><br> O presidente do Metal Bauru Valdemir Caminaga e os diretores de base Marco Antônio e Willians participaram de uma grande caminhada na última quinta-feira, 16, ' +
        'pelas ruas de Itanhaém, fechando a Plenária.<br><br> Em sua fala, Caminaga destacou a importância da luta pelo fim da escala 6 X 1, da redução dos juros, ' +
        'da isenção de Imposto de Renda para quem ganha até R$ 5 mil mensais e da redução de jornada sem redução salarial, para 40 horas semanais. ' + 
        'Esses são pontos de luta ratificados na 9º Plenária.<br><br> Além dos dirigentes de Sindicatos Metalúrgicos de todo o Estado de São Paulo, contribuíram ' +
        'com a Plenária o ministro do Trabalho e Emprego Luiz Marinho, o ex-ministro da Casa Civil José Dirceu, o deputado federal Vicentinho e o deputado estadual ' +
        'Teonilio Barba, ambos do PT.<br><br>Fotos: Adônis Guerra',
      date: '99/99/9999',
      image_post: imageNoticias1001,
      images: [
        {
          content: imageNoticias1001,
          title: ''
        },
        {
          content: imageNoticias1002,
          title: ''
        },
        {
          content: imageNoticias1003,
          title: ''
        },
      ]
    },
    {
      title: 'METAL BAURU MAIS PERTO DA REALIDADE DOS TRABALHADORES',
      slug: 'metal-bauru-mais-perto-da-realidade-dos-trabalhadores',
      content: 'A 9ª Plenária Estatutária da Federação dos Metalúrgicos (FEM-CUT/SP) aprofundou temas importantes que impactam o trabalhador metalúrgico ' +
      'em seu dia a dia. A Plenária ocorreu nos dias 14, 15 e 16 de maio de 2025, reunindo em Itanhaém (SP) diversas lideranças de sindicatos dos metalúrgicos ' +
      'de todo o Estado de São Paulo. <br><br> O Metal Bauru foi representado pelo presidente Valdemir Caminaga e os diretores de base Willians e Marco Antonio. ' +
      'Caminaga destaca as discussões sobre o combate a disseminação de fake news na comunicação com os trabalhadores.<br><br>Ele ressalta que a Plenária fortaleceu o ' +
      'sindicato pelo alto nível das discussões para ação efetiva na base. Caminaga cita como desafios da entidade levantar as bandeiras LGBTQIAPN+, contra o racismo, ' +
      'e fortalecer a luta de combate à violência contra mulheres. <br><br> A 9º Plenária da FEM-CUT/SP aprofundou as discussões de interesse da categoria e também reafirmou ' +
      'a necessidade de avanço nos direitos dos trabalhadores. Entre as pautas destacam-se a luta pelo fim da escala 6 X 1, a redução de jornada sem redução salarial, ' +
      ' para 40 horas semanais, a isenção de Imposto de Renda para quem ganha até R$ 5 mil mensais e a redução dos juros.<br><br>Fotos: Dino Santos',
      date: '99/99/9999',
      image_post: imageNoticias2006,
      images: [
        {
          content: imageNoticias2001,
          title: ''
        },
        {
          content: imageNoticias2002,
          title: ''
        },
        {
          content: imageNoticias2003,
          title: ''
        },
        {
          content: imageNoticias2004,
          title: ''
        },
        {
          content: imageNoticias2005,
          title: ''
        },
        {
          content: imageNoticias2006,
          title: ''
        }
      ]
    },
    {
      title: 'METAL BAURU É DESTAQUE NA PRIMEIRA JORNADA DE LUTAS',
      slug: 'metal-bauru-e-destaque-na-primeira-jornada-de-lutas',
      content: 'A participação da diretoria do Sindicato dos Metalúrgicos de Bauru (Metal Bauru) foi destaque na 1ª Jornada de Lutas Mês do Trabalhador, ' + 
      'promovida na manhã deste sábado, 31, no Parque Vitória Régia. Em sua fala, o presidente do Metal Bauru Valdemir Caminaga ressaltou a importância do mês ' + 
      'de maio para o trabalhador, num momento em que as reivindicações exigem mobilização para avançar nas conquistas.<br><br> A Jornada intensificou a reflexão sobre ' + 
      'questões como a luta pelo fim da escala 6 X 1, a redução de jornada, sem redução salarial, para 40 horas semanais. Outro ponto destacado por Caminaga é a ' + 
      'necessidade de avanços nas negociações da nova Convenção Coletiva de Trabalho (CCT) da categoria, com ampliação de direitos. “Direitos se conquistam com luta”, ' +
      'finalizou Caminaga.<br><br>A 1ª Jornada de Lutas Mês do Trabalhador foi promovida pela Subsede Bauru da CUT/SP, com apoio de diversos sindicatos e coletivos políticos ' + 
      'e culturais, com caráter multicultural.<br><br>Fotos: Ricardo Santana',
      date: '99/99/9999',
      image_post: imageNoticias3001,
      images: [
        {
          content: imageNoticias3001,
          title: ''
        },
        {
          content: imageNoticias3002,
          title: ''
        },
        {
          content: imageNoticias3003,
          title: ''
        },
        {
          content: imageNoticias3004,
          title: ''
        },
        {
          content: imageNoticias3005,
          title: ''
        },
      ]
    },
    {
      title: 'METAL AO LADO DOS TRABALHADORES DA EBARA DEFINE ACORDO DA PLR',
      slug: 'metal-ao-lado-dos-trabalhadores-da-ebara-define-acordo-da-plr',
      content: 'A direção do Sindicato dos Metalúrgicos de Bauru (Metal Bauru) promoveu nesta quarta-feira, 20, uma assembleia com os trabalhadores e trabalhadoras ' + 
      'da Ebara em Bauru. Prestigiaram a ação sindical do Metal Bauru os dirigentes da Federação dos Metalúrgicos (FEM-CUT/SP) Jorge Lima (do ABC) ' + 
      'e Carlão (de Taubaté).<br><br>A direção do Metal Bauru, conduziu a discussão e aprovação pelos trabalhadores da proposta de acordo da PLR. O presidente do Metal ' +
      ' Bauru Valdemir Caminaga junto com os dirigentes Varlei, Willians, Cesar e Marco Antônio, coordenou a assembleia que teve ampla participação e aprovação do ' + 
      'acordo pelos trabalhadores da empresa.<br><br> A assembleia contou com apoio do Jurídico do Sindicato, representado pelo advogado Jorge Moura.<br><br>Fotos: Metal Bauru',
      date: '99/99/9999',
      image_post: imageNoticias4001,
      images: [
        {
          content: imageNoticias4001,
          title: ''
        },
        {
          content: imageNoticias4002,
          title: ''
        },
        {
          content: imageNoticias4003,
          title: ''
        },
        {
          content: imageNoticias4004,
          title: ''
        },
        {
          content: imageNoticias4005,
          title: ''
        },
        {
          content: imageNoticias4006,
          title: ''
        },
      ]
    },
    {
      title: 'CAMPANHA SALARIAL 2025 - ENTREGA DA PAUTA DEFINE RUMO DAS REIVINDICAÇÕES DOS TRABALADORES POR AVANÇOS',
      slug: 'campanha-salarial-2025-entrega-da-pauta-define-rumo-das-reinvincicacoes-dos-trabalhadores-por-avancos',
      content: 'Grupo de diretores do Sindicato dos Metalúrgicos de Bauru (Metal Bauru) fez a entrega em São Paulo da pauta com reivindicações da ' +
      'Campanha Salarial 2025 dos Metalúrgicos. O tom do documento entregue aos representantes dos patrões é de melhorias nas condições sociais para os ' + 
      'trabalhadores metalúrgicos, discutidas com a base nos últimos meses.<br><br>O objetivo, conforme explica o presidente do Metal Bauru Valdemir Caminaga, ' + 
      'é a ampliação de conquista para categoria, como reajuste e aumento real de salários e cláusulas sociais, que tratam da melhoria da condição de vida ' + 
      'do metalúrgico. E mais os pontos das cláusulas específicas de mesa de negociação com cada empresa.<br><br>A Campanha Salarial 2025 também fortalece o conjunto ' + 
      'de reivindicações dos trabalhadores pela redução de jornada sem redução salarial, para 40 horas semanais, fim da jornada 6 X 1, isenção da cobrança de ' + 
      'imposto de renda para quem recebe até 5 mil reais mensais e redução da taxa de juros.<br><br>Caminaga explica que a pauta ainda atende reivindicações específicas ' +
      'do conjunto das mulheres metalúrgicas. “Uma pauta de fôlego e que teremos que ir pra porta de fábrica conversar com trabalhadores e trabalhadoras visando ' + 
      'mobilizar para conquistar todos os avanços”, define Caminaga.<br><br>Fotos: Adônis Guerra',
      date: '99/99/9999',
      image_post: imageNoticias5001,
      images: [
        {
          content: imageNoticias5001,
          title: ''
        },
        {
          content: imageNoticias5002,
          title: ''
        },
      ]
    },
    {
      title: 'PARCERIA ESPORTIVA DESENVOLVE CRIANÇAS, ADOLESCENTES E JOVENS E OBTÉM RESULTADOS EM COMPETIÇÕES',
      slug: 'parceria-esportiva-desenvolve-criancas-adolescentes-e-jovens-e-obtem-resultados-em-competicoes',
      content: 'O projeto de artes marciais, que tem a parceria do Metal Bauru com a Associação de Artes Marciais Caminaga, acumula resultados expressivos nesse ano de 2025 em campeonatos importantes nas modalidades de judô e jiu-jitsu. Sob supervisão dos técnicos voluntários senseis Elisa, Ciça e Christopher, a equipe desempenha importante trabalho impulsionando atletas a almejar pódio em competições importantes como Sul brasileiro, Copa São Paulo de Judô, Campeonato Paulista de Judô, seletiva do J.E.E.S.P., Open Ajinomoto, C.I.J.J.( jiu-jitsu). As conquistas são referência em Bauru e região, confirmando o sucesso da parceria Associação e sindicato para manter o projeto.<br><br>A iniciativa da parceria visa atender as crianças e jovens da comunidade e todos os associados e dependentes do Metal Bauru.<br><br>Fotos: Associação de Artes Marciais Caminaga',
      date: '99/99/9999',
      image_post: imageNoticias6001,
      images: [
        {
          content: imageNoticias6001,
          title: ''
        },
        {
          content: imageNoticias6002,
          title: ''
        },
        {
          content: imageNoticias6003,
          title: ''
        },
        {
          content: imageNoticias6004,
          title: ''
        },
        {
          content: imageNoticias6005,
          title: ''
        },
        {
          content: imageNoticias6006,
          title: ''
        },
        {
          content: imageNoticias6007,
          title: ''
        },
        {
          content: imageNoticias6008,
          title: ''
        },
        {
          content: imageNoticias6009,
          title: ''
        },
        {
          content: imageNoticias6010,
          title: ''
        },
        {
          content: imageNoticias6011,
          title: ''
        },
        {
          content: imageNoticias6012,
          title: ''
        },
        {
          content: imageNoticias6013,
          title: ''
        },
      ]
    },
  ]

  const noticia = elements.find(el => el.slug === slug)

  const domain = window.location.hostname.replace('www.', '')

  const textoCompartilhamento = `${noticia.title} - Leia mais em: https://${domain}/noticias/${noticia.slug}`;
  const urlWhatsapp = `https://wa.me/?text=${encodeURIComponent(textoCompartilhamento)}`;
  return (
    <Row className="align-items-center" style={{ marginTop: '50px', marginBottom: '50px' }}>
      <Col>
        <Breadcrumb>
          <Breadcrumb.Item href="/noticias">
            NOTÍCIAS
          </Breadcrumb.Item>
          <Breadcrumb.Item active>{noticia.title}</Breadcrumb.Item>
        </Breadcrumb>
      </Col>
      <Col xs={12} sm={12} md={12} lg={12}>
        <h1>{noticia.title}</h1>
      </Col>
      <Row className="align-items-center" style={{ width: '100%', marginBottom: '15px' }}>
        <Col xs={12} sm={12} md={9} lg={9} className='texto-cor-primaria' style={{ display: 'none' }}>
          {noticia.date}
        </Col>
        <Col xs={12} sm={12} md={12} lg={12}>
          <Button
            variant='success'
            href={urlWhatsapp}
            target="_blank"
            rel="noopener noreferrer"
            className="d-flex align-items-center justify-content-center"
            style={{ float: 'right', gap: '8px' }}
          >
            <FaWhatsapp /> ENVIAR POR WHATSAPP
          </Button>
        </Col>
      </Row>
      <Col xs={12} sm={12} md={12} lg={12} style={{ marginTop: '20px' }}>
        <TextElement data={noticia} />
      </Col>
      <Col xs={12} sm={12} md={12} lg={12} style={{ marginTop: '20px' }}>
        <CarouselElement data={noticia} />
      </Col>
    </Row>
  )
}

export default NoticiasConteudo